// extracted by mini-css-extract-plugin
export default {"root":"Gn2lgy","rootSize72":"i2FSzB","icon":"wqo3MX","rootSize56":"jg3jYq","rootSize40":"HnnZM1","rootSize32":"x8aWFI","rootSize24":"itMRQo","rootSize18":"uBWeb5"};